import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  DataTableHeaderCell,
  type HeaderResizeProps,
} from "./DataTableHeaderCell";
import type { SortDirection } from "./tableTypes";

type SortableHeaderProps<T extends string> = {
  label: string;
  column: T;
  activeColumn: T;
  direction: SortDirection;
  onSort: (column: T) => void;
  align?: "left" | "right";
  className?: string;
} & HeaderResizeProps;

export function SortableHeader<T extends string>({
  label,
  column,
  activeColumn,
  direction,
  onSort,
  align = "left",
  className,
  ...resize
}: SortableHeaderProps<T>) {
  const isActive = activeColumn === column;
  const SortIcon = isActive
    ? direction === "asc"
      ? ArrowUp
      : ArrowDown
    : ArrowUpDown;

  return (
    <DataTableHeaderCell
      className={className}
      ariaSort={
        isActive ? (direction === "asc" ? "ascending" : "descending") : "none"
      }
      {...resize}
    >
      <button
        type="button"
        onClick={() => onSort(column)}
        title={label}
        className={cn(
          "inline-flex w-full items-center gap-1 text-xs font-medium transition-colors hover:text-surface-900",
          align === "right" ? "justify-end" : "justify-start",
          isActive ? "text-surface-900" : "text-surface-500",
        )}
      >
        <span className="min-w-0 truncate text-left">{label}</span>
        <SortIcon
          className={cn("h-3.5 w-3.5 shrink-0", !isActive && "opacity-40")}
          aria-hidden
        />
      </button>
    </DataTableHeaderCell>
  );
}
